<template>
  <div class="content">
    <div class="panel">
      <div class="btn-container u-pull-right">
        <back-button></back-button>
      </div>
      <h1 class="font-light">Change Password</h1>
      <div class="divider u-no-margin"></div>
      <div class="panel">
        To change your <strong>password</strong> please enter your
        <i>current</i> password, then enter your <i>new password twice</i>
        <br />
        If you don't know your current password then you can
        <router-link style="display: inline" :to="{ name: 'reset-password' }">
          click here</router-link
        >
        to reset it.
      </div>
      <div class="form-section">
        <!-- Current Password -->
        <div class="row level">
          <div class="offset-2 col-10 error" v-if="error.current_password">
            {{ error.current_password }}
          </div>
          <div class="col-2 level-item font-bold">
            <span class="u-fill-width">
              Current Password:
            </span>
          </div>
          <div class="col-10 level-item input-control">
            <input
              v-model="formData.current_password"
              v-bind:class="{ 'input-error': error.current_password }"
              type="password"
              placeholder="Super Secret Password"
              class="input-contains-icon"
            />
            <span class="icon">
              <i class="fa fa-wrapper fa-key"></i>
            </span>
          </div>
        </div>
        <!-- Password field -->
        <div class="row level">
          <div class="offset-2 col-10 error" v-if="error.new_password">
            {{ error.new_password }}
          </div>
          <div class="col-2 level-item font-bold">
            <span class="u-fill-width">New Password:</span>
          </div>
          <div class="col-10 level-item input-control">
            <input
              v-model="formData.new_password"
              v-bind:class="{ 'input-error': error.new_password }"
              type="password"
              placeholder="A Different Super Secret Password"
              class="input-contains-icon"
            />
            <span class="icon">
              <i class="fa fa-wrapper fa-unlock-alt"></i>
            </span>
          </div>
        </div>
        <!-- Re-Password field -->
        <div class="row level">
          <div class="offset-2 col-10 error" v-if="error.re_new_password">
            {{ error.re_new_password }}
          </div>
          <div class="col-2 level-item font-bold">
            <span class="u-fill-width" style="white-space: nowrap;"
              >Confirm Password:</span
            >
          </div>
          <div class="col-10 level-item input-control">
            <input
              v-model="formData.re_new_password"
              v-bind:class="{ 'input-error': error.re_new_password }"
              type="password"
              placeholder="How well can you type?"
              class="input-contains-icon"
            />
            <span class="icon">
              <i class="fa fa-wrapper fa-unlock-alt"></i>
            </span>
          </div>
        </div>
        <space></space>
        <div class="row">
          <div class="u-text-right u-fill-width">
            <button
              class="btn-primary u-pull-right --tas-button-side-margin"
              v-on:click="changePassword"
              value="Login"
              type="submit"
            >
              <loading-spinner v-show="submit"></loading-spinner>
              <i
                class="fa-wrapper fa fa-paper-plane pad-right"
                v-show="!submit"
              ></i>
              Change Password
            </button>
          </div>
        </div>
      </div>
    </div>
    <toast-success
      v-if="success"
      v-bind:label="'Password Updated'"
      v-bind:message="'Your password has been updated.'"
      v-on:close="closeSuccess"
    >
    </toast-success>
    <server-error v-bind:error="error.serverError"></server-error>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ServerError from "@/components/ServerError";
import BackButton from "@/components/BackButton";
import LoadingSpinner from "@/components/LoadingSpinner";
import ToastSuccess from "@/components/ToastSuccess";
import * as authService from "@/services/auth.service";
import { handleError } from "@/functions/handleError.function";

export default {
  name: "change-password",
  components: {
    ServerError,
    BackButton,
    LoadingSpinner,
    ToastSuccess
  },
  data: function() {
    return {
      formData: {
        current_password: undefined,
        new_password: undefined,
        re_new_password: undefined
      },
      success: false,
      submit: false
    };
  },
  computed: {
    ...mapGetters("core", ["error"])
  },
  methods: {
    validate_form: function() {
      var valid = true;
      if (!this.formData.current_password) {
        this.$store.commit("core/setError", {
          current_password: "You must enter your current password."
        });
        valid = false;
      }
      if (!this.formData.new_password) {
        this.$store.commit("core/setError", {
          new_password: "You must enter a new password."
        });
        valid = false;
      }
      if (this.formData.new_password == this.formData.current_password) {
        this.$store.commit("core/setError", {
          new_password:
            "Your new password can't be the same as your old one (!)"
        });
        valid = false;
      }
      if (this.formData.new_password != this.formData.re_new_password) {
        this.$store.commit("core/setError", {
          re_new_password:
            "This doesn't match your new password. Check your spelling?"
        });
        valid = false;
      }
      return valid;
    },
    changePassword: function() {
      this.$store.commit("core/clearErrors");
      this.submit = true;
      if (this.validate_form() == false) {
        this.submit = false;
        return; // Break if not valid
      }
      authService
        .setPassword(this.formData)
        .then(response => {
          if (response.status == 204) {
            this.submit = false;
            this.success = true;
          }
        })
        .catch(error => {
          this.submit = false;
          this.success = false;
          let data = handleError(error);
          this.$store.commit("core/setError", data);
        });
    },
    closeSuccess: function() {
      this.success = false;
    }
  },
  mounted() {
    this.$store.commit("core/clearErrors");
  }
};
</script>
